// Sound effects using hosted MP3 files via Audio elements.
// Audio elements can load cross-origin files without CORS.
// warmUp() plays a tiny silent MP3 data-URI during the user gesture
// to unlock audio playback on mobile browsers (iOS Safari etc.).

const BASE = 'https://www.mattmcwilliams.com/wp-content/uploads/2026/07';

const cache = {};
let unlocked = false;

// Minimal valid silent MP3 frame — used to unlock audio during user gesture
const SILENCE = 'data:audio/mpeg;base64,SUQzBAAAAAABEVRTU0UAAAAPAAADTGF2ZjU4Ljc2LjEwMAAAAAAAAAAAAAAA//tQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWGluZwAAAA8AAAACAAABhgC7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7//////////////////////////////////////////////////////////////////8AAAAATGF2YzU4LjEzAAAAAAAAAAAAAAAAJAAAAAAAAAAAAYYoRwBHAAAAAAAAAAAAAAAAAAAA//tQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA';

function play(url) {
  try {
    if (!cache[url]) {
      cache[url] = new Audio(url);
      cache[url].preload = 'auto';
      cache[url].load();
    }
    const audio = cache[url];
    // If already playing, clone so overlapping calls both play
    if (!audio.paused) {
      const clone = new Audio(url);
      clone.play().catch(() => {});
      return;
    }
    audio.currentTime = 0;
    audio.play().catch(() => {});
  } catch {}
}

// Call synchronously inside a click/tap handler BEFORE any await.
// Plays a silent MP3 data-URI to unlock audio on mobile browsers,
// then all subsequent Audio.play() calls work even after async gaps.
export function warmUp() {
  if (unlocked) return;
  try {
    const a = new Audio(SILENCE);
    a.play()
      .then(() => { unlocked = true; })
      .catch(() => {});
  } catch {}
}

// Pre-load all sound files so they play instantly when needed
export function preload() {
  for (let i = 1; i <= 12; i++) {
    const url = `${BASE}/${i}.mp3`;
    if (!cache[url]) {
      cache[url] = new Audio(url);
      cache[url].preload = 'auto';
      cache[url].load();
    }
  }
}

export const sounds = {
  drillComplete(didExtra = false) {
    play(didExtra ? `${BASE}/2.mp3` : `${BASE}/1.mp3`);
  },

  quizCorrect() {
    play(`${BASE}/3.mp3`);
  },

  quizWrong() {
    play(`${BASE}/4.mp3`);
  },

  quizComplete() {
    play(`${BASE}/5.mp3`);
  },

  levelUp(isPrestige = false) {
    play(isPrestige ? `${BASE}/7.mp3` : `${BASE}/6.mp3`);
  },

  badgeEarned() {
    play(`${BASE}/8.mp3`);
  },

  streakMilestone() {
    play(`${BASE}/9.mp3`);
  },

  perfectWeek() {
    play(`${BASE}/10.mp3`);
  },

  firstCompletion() {
    play(`${BASE}/11.mp3`);
  },

  leaderboardRankUp() {
    play(`${BASE}/12.mp3`);
  },
};
